<template>
    <div class="home">
     
      <DetalleHomeComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import DetalleHomeComponent from '@/components/DetalleHomeComponent.vue'
  
  export default {
    name: 'CotizacionView',
    components: {
        DetalleHomeComponent
    }
  }
  </script>